import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { ListItem, IconButton } from '@material-ui/core'
import { mutualTheme } from '~/utils/theme'
import { NavLink, NavLinkProps } from 'react-router-dom'
import { transparentize } from 'polished'

const useStyles = makeStyles({
  listItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  button: {
    backgroundColor: transparentize(0.80, mutualTheme.palette.common.black),
    color: transparentize(0.80, mutualTheme.palette.common.white),
    '&:hover': {
      color: transparentize(0.20, mutualTheme.palette.common.white),
      backgroundColor: mutualTheme.palette.secondary.main
    }
  },
  buttonActive: {
    color: transparentize(0.20, mutualTheme.palette.common.white),
    backgroundColor: mutualTheme.palette.secondary.main
  }
})

const NavigationLink = React.forwardRef((props: NavLinkProps, ref: any) => <NavLink {...props} ref={ref} />)

export type SidebarButtonProps = {
  to?: string,
  onClick?: () => void
}

export const SidebarButton: React.FC<SidebarButtonProps> = (props) => {
  const classes = useStyles()

  return (
    <ListItem className={classes.listItem}>
      {props.to
        ? (
          <IconButton
            component={NavigationLink}
            to={props.to}
            className={classes.button}
            activeClassName={props.onClick ? '' : classes.buttonActive}
          >{props.children}</IconButton>
        )
        : (
          <IconButton
            onClick={props.onClick}
            className={classes.button}
          >{props.children}</IconButton>
        )}
    </ListItem>
  )
}
